const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        // api: "https://localhost:44348/",
        api: "https://vungtau-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
  },
  production: {
      api: "https://vungtau-api.cgis.asia/",
      domainAdminSide: "https://admin.vungtau.cgis.asia",
      domainUserSide: "https://vungtau.cgis.asia",
      domainName: "vungtau.cgis.asia",
  },
};

module.exports = apiEnvironment[env];
